import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FileUploadButton from '../fileUpload/fileUploadButton.component';
import { acceptedExcelFileExtensions } from '../fileUpload/constants';

const ExcelImportButton = ({ children, onClick, className, ...restProps }) => (
  <FileUploadButton
    accept={acceptedExcelFileExtensions}
    className={classNames(className, 'upload-file-button')}
    onChange={onClick}
    {...restProps}
  >
    {children}
  </FileUploadButton>
);

ExcelImportButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

ExcelImportButton.defaultProps = {
  className: '',
};

export default ExcelImportButton;
